<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Promo Mobile</h5>
            </template>
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group
                    label="Filter"
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <b-form-select class="ml-2 mr-2" @change="onFilter" v-model="input.filterStatus" id="filterInput" name="statusPromo" :options="statusPromo" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled >-- Pilih filter status --</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-form-input class="mr-2"
                            v-model="input.filterName" name="filterName"
                            type="search"
                            placeholder="Nama Promo"
                            @keyup="onFilter"
                        ></b-form-input>
                        <!-- <b-button class="mr-2" variant="pgiBtn" :disabled="isBusy" name="searchTableBtn" @click="onFilter"> 
                            <i class="fa fa-search"></i>
                        </b-button> -->
                        <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                    </div>
                </b-form-group>
                <b-button class="mb-3" variant="pgiBtn" name="promoAddBtn" @click="inputPromo">Input Promo</b-button>
            </div>
       
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="promo" 
                :fields="fields"
                :no-local-sorting="false"
                @sort-changed="sortingChanged" 
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data promo.
                </template>
                <template v-slot:cell(title)="row">
                    <p class="mb-0">{{row.item.title}}</p>
                </template>
                <template v-slot:cell(pathImage)="row">
                    <b-button @click="preview($baseFilePath + row.item.pathImage)">
                        <img :src="$baseFilePath + row.item.pathImage" width="50px" alt="">
                    </b-button>
                </template>
                <template v-slot:cell(link)="row">
                   <a :href="'https://' + row.item.link" >{{ row.item.link }}</a>
                </template>
                <template v-slot:cell(tokenHeader)="row">
                    <b-badge variant="success" v-if="row.item.tokenHeader == true">True </b-badge>
                    <b-badge variant="danger" v-else-if="row.item.tokenHeader == false">False</b-badge>
                </template>
                <template v-slot:cell(isActive)="row">
                    <b-badge variant="success" v-if="row.item.isActive == true">True </b-badge>
                    <b-badge variant="danger" v-else-if="row.item.isActive == false">False</b-badge>
                </template>
               
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-link :to="`${$route.path}/${row.item.id}`">
                            <b-button size="sm" class="mr-3 table-button view" v-b-tooltip.hover title="Detail" name="promoViewBtn">
                                <i class="fa fa-info"></i>
                            </b-button>
                        </b-link>
                        <b-link :to="`${$route.path}/${row.item.id}/edit`">
                            <b-button size="sm" class="table-button edit" v-b-tooltip.hover title="Edit" name="promoEditBtn">
                                <i class="fa fa-pencil-square-o"></i>
                            </b-button>
                        </b-link>
                    </div>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" :options="options" @change="onLimitChange">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">PENDING</h6>
                <p class="smallText mb-0">Promo ini sudah disiapkan, namun belum berjalan karena masih diluar periode promo.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">BERJALAN</h6>
                <p class="smallText mb-0">Promo ini sedang berjalan dan dapat digunakan saat melakukan penggadaian.</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">SELESAI</h6>
                <p class="smallText mb-0">Promo ini sudah selesai dan tidak dapat digunakan lagi saat melakukan penggadaian.</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
        <ModalPreview modalId="modal-preview-gadai" :fotoPreview="activeFotoPreview" />
    </div>
</template>

<script>
import ModalPreview from '../../../components/webcam/ModalPreview'
export default {
    name: 'master-promo',
    components: {
        ModalPreview,
    },
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            input:{
                show: 10,
                filterName: null,
                filterStatus: null,
                sortBy: null,
                sortDesc: null
            },
            activeFotoPreview: "",
            fields: [
                { key: "title", label: "Nama Promo", sortable:true },
                { key: "pathImage", label: "Foto Promo" },
                { key: "link", label: "Link"},
                { key: "tokenHeader", label: "Token"},
                { key: "isActive", label: "Is Active" },
                { key: "action", label: "Aksi" },
            ],
            statusPromo: [
                { id: 0, name: 'Non-Aktif'},
                { id: 1, name: 'Aktif'},
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            promo: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: ""
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.page = 0
            this.size = 10
            this.query = this.$helper.makeQuery(this.page, this.size)

            let getPromo = this.$axios.get("/promo-mobile/" + this.query).then(response => {
                this.promo = response.data.data
                this.updateTotalItem(response.data.total)
            })

            Promise.all([getPromo]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },


        //----------------- Fungsi Ambil Data Promo -----------------

        getPromo(){
            this.toggleBusy()
            this.promo = []

            if(this.input.filterStatus != null) this.query = this.query + "&filterStatus=" + this.input.filterStatus
            if(this.input.filterName != null) this.query = this.query + "&filterName=" + this.input.filterName
         
            this.$axios.get("promo-mobile/"+this.query).then(response => {
                this.promo = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------
        
        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getPromo()
        },

        onPageChange(){
            if (this.loading == false) {
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getPromo()
            }
        },

        sortingChanged(ctx) {
            if(ctx.sortBy == "persen"){
                this.input.sortBy = "nominalPersen"
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            }else if(ctx.sortBy != ""){
                this.input.sortBy = ctx.sortBy
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onReset(){
            this.input.filterStatus = null
            this.input.filterName = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getPromo()
        },

        onFilter(){
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getPromo()
        },

        preview(foto){
            this.activeFotoPreview = foto
            this.$bvModal.show("modal-preview-gadai")
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        inputPromo(){
            this.$router.push({path: `${this.$route.path}/input`});
        }
    },

    created(){
        this.init()
    }
}
</script>
